"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapProviderCard = void 0;
const react_1 = __importStar(require("react"));
const useProviderContent_1 = require("../common/util/useProviderContent");
const MapProviderCard_styles_1 = require("./MapProviderCard.styles");
const image_component_1 = require("@kyruus/image-component");
const ProviderName_1 = require("./ProviderName");
const ProviderSpecialties_1 = require("./ProviderSpecialties");
const ProviderRatingSummary_1 = require("./ProviderRatingSummary");
const util_1 = require("../common/util");
const intl_1 = require("@kyruus/intl");
const intl_2 = require("@kyruus/intl");
const MapProviderCard = (_a) => {
    var { provider, config = {}, availability, location, providerReviews, viewProviderUrl, onViewProvider, bookOnlineUrl, onBookAppointment } = _a, restProps = __rest(_a, ["provider", "config", "availability", "location", "providerReviews", "viewProviderUrl", "onViewProvider", "bookOnlineUrl", "onBookAppointment"]);
    // Extract provider content using the hook
    const { id, name, imageUrl, specialties } = (0, useProviderContent_1.useProviderContent)({
        provider,
        config,
        availability,
        location
    });
    const intl = (0, intl_2.useIntl)();
    const { config: imageConfig } = (0, image_component_1.useImageService)();
    const MapProviderImageWrapperComponent = (imageConfig === null || imageConfig === void 0 ? void 0 : imageConfig.enableEnhancement)
        ? MapProviderCard_styles_1.ImageWrapperWithEnhancement
        : MapProviderCard_styles_1.ImageWrapper;
    const hasContentToRender = (name && name.trim().length > 0) || (specialties && specialties.length > 0);
    const hasRatings = providerReviews && providerReviews.aggregate_ratings;
    const buildAriaLabel = (0, react_1.useCallback)(() => {
        var _a;
        if (restProps['aria-label']) {
            return restProps['aria-label'];
        }
        const summary = [];
        if (name)
            summary.push(name);
        if (specialties === null || specialties === void 0 ? void 0 : specialties[0]) {
            summary.push(specialties[0]);
            if (specialties.length > 1) {
                summary.push(`and ${specialties.length - 1} other specialties`);
            }
        }
        if ((_a = providerReviews === null || providerReviews === void 0 ? void 0 : providerReviews.aggregate_ratings) === null || _a === void 0 ? void 0 : _a.average_rating) {
            const rating = providerReviews.aggregate_ratings.average_rating;
            const count = providerReviews.aggregate_ratings.rating_count;
            summary.push(`${rating} out of 5 stars, ${count} ratings`);
        }
        return `Provider: ${summary.join(', ')}`;
    }, [name, specialties, providerReviews, restProps]);
    return (react_1.default.createElement(MapProviderCard_styles_1.MapProviderCardContainer, Object.assign({ "aria-label": buildAriaLabel(), "data-testid": "map-provider-card" }, restProps),
        (imageUrl || hasContentToRender) && (react_1.default.createElement(MapProviderCard_styles_1.MapProviderRowContainer, null,
            imageUrl && (react_1.default.createElement(MapProviderImageWrapperComponent, null,
                react_1.default.createElement(MapProviderCard_styles_1.MapProviderImage, { altText: name, id: `map-provider-image-${id}`, "data-testid": `map-provider-image-${id}`, src: imageUrl, itemProp: "image", "aria-hidden": true, draggable: false, enabledEnhancement: (imageConfig === null || imageConfig === void 0 ? void 0 : imageConfig.enableEnhancement) || false }))),
            hasContentToRender && (react_1.default.createElement(MapProviderCard_styles_1.MapProviderContentWrapper, { "data-testid": "map-content-wrapper" },
                name && name.trim().length > 0 && (react_1.default.createElement(ProviderName_1.ProviderName, { name: name, id: id, viewProviderUrl: viewProviderUrl, onViewProvider: onViewProvider })),
                specialties && specialties.length > 0 && (react_1.default.createElement(ProviderSpecialties_1.ProviderSpecialties, { id: id, specialties: specialties })))))),
        hasRatings && (react_1.default.createElement(ProviderRatingSummary_1.ProviderRatingSummary, { providerReviews: providerReviews })),
        bookOnlineUrl && (react_1.default.createElement(MapProviderCard_styles_1.BookAppointmentCta, { "data-testid": `map-provider-card-button-${id}`, mode: "ghost", href: bookOnlineUrl, onClick: onBookAppointment, draggable: false, "aria-label": intl.formatMessage(util_1.messages.ariaBookButton, {
                name
            }) },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, util_1.messages.ctabutton))))));
};
exports.MapProviderCard = MapProviderCard;
//# sourceMappingURL=MapProviderCard.js.map